import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: ${({ theme }) => theme.space[10]}px;
`;
